import classNames from "classnames";

import "./Button.scss";
import LoadingIcon from "@/components/atom/Icons/LoadingIcon";
interface IProps {
  onClick?: () => void;
  label: string;
  isLoading?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
}
const Button = ({ onClick, disabled, label, isLoading, type, className }: IProps) => {
  return (
    <button
      type={type ? type : "submit"}
      disabled={isLoading || disabled}
      className={classNames(`form-btn ${className}`, {
        loading: isLoading,
        disabled: disabled,
      })}
      onClick={onClick}
    >
      <span>
        <span>{isLoading ? <LoadingIcon /> : label}</span>
      </span>
    </button>
  );
};

export default Button;
